import { CollisionGroupManager } from 'excalibur';

export const statueCollisionGroup = CollisionGroupManager.create('pipes');
export const pointsCollisionGroup = CollisionGroupManager.create('points');
